"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CfgLanguageEditor = /** @class */ (function (_super) {
    __extends(CfgLanguageEditor, _super);
    function CfgLanguageEditor(props) {
        return _super.call(this, props) || this;
    }
    CfgLanguageEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    code: _item.code,
                    is_deprecated: _item.is_deprecated
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование языка"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                code: "",
                is_deprecated: false
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание языка"]);
            });
        }
        this.doReSetRules();
    };
    CfgLanguageEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            code_rules: { isError: false },
        });
    };
    CfgLanguageEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                code: this.state.code,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Язык изменен!");
            });
        }
    };
    CfgLanguageEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.code) || (this.state.code.length === 0)) {
            this.setState({ code_rules: { isError: true, errorMessage: "Поле [код] не заполнено!" } });
            return false;
        }
        return true;
    };
    CfgLanguageEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                code: this.state.code,
                title: this.state.title,
                is_deprecated: this.state.is_deprecated
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Язык добавлен!");
            });
        }
    };
    CfgLanguageEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    CfgLanguageEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить язык";
        }
        else {
            return "Изменить язык";
        }
    };
    CfgLanguageEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) { _this.setState({ title: newVal, title_rules: { isError: false } }); }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Код:", placeholder: "Введите код" }, value: this.state.code, onValueChanged: function (newVal) { _this.setState({ code: newVal, code_rules: { isError: false } }); }, required: true, rules: this.state.code_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Язык неактуален", value: this.state.is_deprecated, onChecked: function (checked) { _this.setState({ is_deprecated: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return CfgLanguageEditor;
}(React.Component));
exports.default = CfgLanguageEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cfg_language/ui/component/CfgLanguageEditor.tsx
// module id = 2164
// module chunks = 0